import { render, staticRenderFns } from "./DocumentVerify.vue?vue&type=template&id=5585dbd9&scoped=true"
import script from "./DocumentVerify.vue?vue&type=script&lang=js"
export * from "./DocumentVerify.vue?vue&type=script&lang=js"
import style0 from "./DocumentVerify.vue?vue&type=style&index=0&id=5585dbd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5585dbd9",
  null
  
)

export default component.exports